/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Page, Button, Container, Box } from "@common-ui/ui";
import { Auth } from "aws-amplify";

import { Header, ToggleViews } from "../../components";
import { AssetTableView } from "./AssetTableView";
import { AssetListView } from "./AssetListView";
import { AssetCardView } from "./AssetCardView";
import { getAssets } from "../../services/Assets";
import { Add, ArrowDropDown } from "@mui/icons-material";
import { RemoveCustomerDialog } from "./RemoveCustomerDialog";
import { CreateAssetDialog } from "./CreateAssetDialog";
import { useSelector } from "react-redux";

import { ModalContext } from "../../components/BrowserAlert/modalContext";
import {
  getCustomerPlaces,
  getOrgPlaces,
  getUserCustomers,
  getUserOrgsRelated,
} from "../../services";
import { orderBy } from "lodash";
import { CompleteAssetDialog } from "./CompleteAssetDialog";
import { flattenTree } from "../../utils";
import { Divider } from "@mui/material";

export const AssetList = ({ ...props }) => {
  const [view, setView] = useState("table-view");
  const [assets, setAssets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [currentCustomerId, setCurrentCustomerId] = useState(undefined);
  const [currentOrgId, setCurrentOrgId] = useState(undefined);
  const [orgId, setOrgId] = useState("");
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [openCompleteAssetDialog, setOpenCompleteAssetDialog] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [remove, setRemove] = useState(undefined);
  const [toast, setToast] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [newPlaceParent, setNewPlaceParent] = useState(undefined);
  const [customer, setCustomer] = useState(null);
  const [newCustomer, setNewCustomer] = useState(null);
  const [places, setPlaces] = useState([]);

  const [placesParent, setPlacesParent] = useState(undefined);

  const currentOrganization = useSelector(
    (state) => state?.organization?.currentOrganization
  );
  let appRole = currentOrganization?.app_role;
  let doesUserHavePermission =
    appRole !== "TECHNICIAN" &&
    (appRole === "SUPERVISOR" || appRole === "ADMIN");

  let { handleModal } = React.useContext(ModalContext);

  const handleView = (event, newView) => {
    setView(newView);
  };
  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    try {
      let { assets, orgId } = await getAssets();
      setAssets(assets);
      setOrgId(orgId);

      if (doesUserHavePermission) {
        try {
          let internalOrgs = await getUserOrgsRelated();
          internalOrgs = flattenTree(internalOrgs);
          // internalOrgs = internalOrgs;
          let externalOrgs = await getUserCustomers();
          const newData = orderBy(
            [...internalOrgs, ...externalOrgs],
            ["name"],
            ["asc"]
          );
          setClientData(newData);
          setNewCustomer(null);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          console.log(error);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setAssets([]);
      setNewCustomer(null);
      handleModal(error, "ERROR");
    }
  }

  useEffect(() => {
    setNewPlaceParent && setNewPlaceParent(placesParent);
  }, [placesParent]);

  useEffect(async () => {
    await getParent(customer);
  }, [customer, JSON.stringify(places)]);

  async function getParent(item) {
    if (!item) return;
    if (placesParent) return;
    try {
      let placesData = [];
      if (item.system_id) {
        placesData = await getCustomerPlaces(item.org, item.system_id);
      } else {
        placesData = await getOrgPlaces(item.id);
      }

      if (!props.places.length) {
        setPlacesParent(undefined);
      } else {
        if (!placesParent && props.places[0]) {
          function getParent(nodes, parent = undefined) {
            if (
              String(nodes.system_id).toLowerCase() ===
              String(props.places[0]).toLowerCase()
            ) {
              setPlacesParent(parent);
              return;
            } else if (Array.isArray(nodes.child_places)) {
              for (let childNode of nodes.child_places) {
                getParent(childNode, parent);
              }
            } else return;
          }
          for (let i = 0; i < placesData.length; i++) {
            getParent(placesData[i], placesData[i]);
          }
        }
      }
    } catch (error) {
      console.log(error);
      // alert(error);
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleRemove = () => {
    if (remove === "customer") {
      setPlacesParent(undefined);
      setPlaces([]);
      setCustomer(null);
      setToast([
        ...toast,
        {
          message: "Client has been removed successfully.",
          open: true,
          severity: "success",
        },
      ]);
      setRemove(undefined);
    } else {
      setPlacesParent(undefined);
      setPlaces([]);
      setToast([
        ...toast,
        {
          message: "Places has been removed successfully.",
          open: true,
          severity: "success",
        },
      ]);
      setRemove(undefined);
    }
  };

  const displayData = () => {
    switch (view) {
      case "list-view":
        return <AssetListView isLoading={isLoading} rows={assets} />;

      case "card-view":
        return <AssetCardView isLoading={isLoading} rows={assets} />;

      default:
        return (
          <AssetTableView
            isLoading={isLoading}
            isShowTableHeader={false}
            rows={assets}
            orgId={orgId}
            setCurrentOrgId={setCurrentOrgId}
            setCurrentCustomerId={setCurrentCustomerId}
            setOpenRemoveDialog={setOpenRemoveDialog}
          />
        );
    }
  };

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        name={`All Assets (${assets?.length})`}
        history={history}
        menuBar
        action={
          doesUserHavePermission ? (
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              endIcon={
                <>
                  <Divider orientation="vertical" flexItem />
                  <ArrowDropDown />
                </>
              }
              onClick={() => setOpenCreateDialog(true)}
              // onClick={() => history.push("/create-asset")}
            >
              New Asset
            </Button>
          ) : (
            ""
          )
        }
      />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Box sx={{ my: 2 }}>
          <ToggleViews view={view} handleView={handleView} />
        </Box>
        {displayData()}
      </Container>
      <RemoveCustomerDialog
        handleClose={() => {
          setCurrentCustomerId(undefined);
          setOpenRemoveDialog(false);
        }}
        currentCustomerId={currentCustomerId}
        currentOrgId={currentOrgId}
        open={openRemoveDialog}
        getUserCustomers={getAssets}
        setCustomers={setAssets}
      />
      <CreateAssetDialog
        open={openCreateDialog}
        handleClose={() => {
          setOpenCreateDialog(false);
        }}
        currentOrgId={currentOrgId}
        clientData={clientData}
        setCustomer={setCustomer}
        setPlaces={setPlaces}
        setNewCustomer={setNewCustomer}
        customer={customer}
        places={places}
        placesParent={placesParent}
        setPlacesParent={setPlacesParent}
        setOpenCompleteAssetDialog={() => {
          setOpenCompleteAssetDialog(true);
        }}
      />
      <CompleteAssetDialog
        open={openCompleteAssetDialog}
        handleClose={() => {
          setOpenCompleteAssetDialog(false);
        }}
        currentOrgId={currentOrgId}
        clientData={clientData}
        setCustomer={setCustomer}
        setPlaces={setPlaces}
        customer={customer}
        places={places}
        placesParent={placesParent}
        setPlacesParent={setPlacesParent}
        newPlaceParent={newPlaceParent}
        newCustomer={newCustomer}
        setAssets={setAssets}
        init={init}
        setOpenCreateDialog={() => {
          setOpenCreateDialog(true);
        }}
      />
    </Page>
  );
};
